export default "__VITE_ASSET__65aWVYbD__"